import { cn } from '@/lib/utils';
import { TYPE, ACCENT } from './tokens';

interface SectionHeaderProps {
  eyebrow?: string;
  headline: React.ReactNode;
  description?: React.ReactNode;
  headlineId?: string;
  centered?: boolean;
  size?: 'lg' | 'xl';
  inverted?: boolean;
}

export function SectionHeader({
  eyebrow,
  headline,
  description,
  headlineId,
  centered = false,
  size = 'lg',
  inverted = false,
}: SectionHeaderProps) {
  const headlineCls = size === 'xl' ? TYPE.displayLg : TYPE.headlineLg;
  return (
    <div
      className={cn(
        'max-w-3xl',
        centered && 'mx-auto text-center',
      )}
    >
      {/* Deko-Dot entfernt (Skill-Review 2026-07-31: dekorative Status-
          Punkte ohne Semantik sind gebannt — der uniforme „• LABEL"-Auftakt
          auf jeder Sektion war das größte Template-Signal der Seite) */}
      {eyebrow && (
        <p
          className={cn(
            TYPE.labelMd,
            inverted ? 'text-blue-400' : ACCENT.text,
          )}
        >
          {eyebrow}
        </p>
      )}
      <h2
        id={headlineId}
        className={cn(
          headlineCls,
          eyebrow && 'mt-3',
          inverted ? 'text-white' : 'text-gray-950',
        )}
      >
        {headline}
      </h2>
      {description && (
        <p
          className={cn(
            TYPE.sectionSub,
            'mt-4 sm:mt-5',
            inverted && 'text-gray-300',
          )}
        >
          {description}
        </p>
      )}
    </div>
  );
}
